import { Image, OverlayTrigger } from "react-bootstrap"
import BaseControl from "./BaseControl"
import Label from "./Label"

const FileInputControl = ({
    id="", 
    text="Text", 
    caption="", 
    value="", 
    edit=true,
    isImage=false,
    type="text",
    inputSize=4,
    onChanged=(id:string, val:FileList | null)=>{}}) => {
    
    return <BaseControl text={text} caption={caption} contentSize={inputSize}>
        <>
        { edit && <input id={id} 
            type={type} 
            style={{height:'30px',textAlignLast:"end"}} 
            defaultValue={value} 
            onChange={e => onChanged(id, e.target.files)}/>}
        { !isImage && !edit && <Label fontWeight="400" textAlign='end' padding="">
            {type === 'number' || value.length < 20 ? value : value.substring(0,20) + "..."}
            </Label>}
        { isImage && !edit && <OverlayTrigger overlay={<Image style={{backgroundColor:'white'}} src={value} height={100}/>}>
                {({ref, ...triggerHandler}) => (
                    <Image ref={ref} {...triggerHandler} src={value} height={20}/>
                )}
            </OverlayTrigger>}
        </>
    </BaseControl>
}

export default FileInputControl